<template>
    <div>
        <div class="navbar fixed z-20 w-full bg-[rgba(106,153,143,.85)] backdrop-blur-md font-merriweather">
            <div class="h-12 flex flex-row justify-between">
                <div class="site-title text-xl text-[#eaf2ef] font-medium flex items-center ml-4 h-full" @click.prevent="closeMenuTitle">Clair Green</div>
                <button class="hamburger mr-4 relative w-10 grid place-items-center" aria-label="Open Menu" @click="toggleMenu">
                    <span class="hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md
                        transition-all duration-300 ease-in-out"
                        :class="isOpen ? 'translate-y-0 rotate-45' : '-translate-y-2 rotate-0'"
                    ></span>
                    <span class="hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md
                        transition-all duration-200 ease-in-out"
                        :class="isOpen ? 'opacity-0' : 'opacity-100'"
                    ></span>
                    <span class="hamburger-item w-8 h-[3px] absolute bg-[#eaf2ef] drop-shadow-[0_0_3px_#a8c3b4] rounded-md
                        transition-all duration-300 ease-in-out"
                        :class="isOpen ? 'translate-y-0 -rotate-45' : 'translate-y-2 rotate-0'"
                    ></span>
                </button>
            </div>
        </div>
        <Transition name="menu-slide">
            <div v-if="isOpen" 
                class="navbar bg-[rgba(106,153,143,0.85)] p-10 left-0 top-12 w-full h-[calc(100vh-3rem)] 
                flex flex-col fixed z-1000 backdrop-blur-md overflow-auto"
            >
                <div class="flex flex-col items-center justify-center gap-8 mt-10">
                    <router-link to="/" class="link text-2xl" @click="toggleMenu">Home</router-link>
                    <MobileNavDropdown :title="'About Me'" :options="aboutMeOptions" @close-menu="toggleMenu"></MobileNavDropdown>
                    <MobileNavDropdown :title="'My Projects'" :options="projectsOptions" @close-menu="toggleMenu"></MobileNavDropdown>
                    <router-link to="/skills-experience" class="link text-2xl" @click="toggleMenu">Skills & Experience</router-link>
                    <router-link to="/contact" class="link text-2xl" @click="toggleMenu">Contact Me</router-link>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
import { watch, ref } from 'vue';
import { useRouter } from 'vue-router';
import MobileNavDropdown from '../global/MobileNavDropdown.vue';

const router = useRouter();

const isOpen = ref(false);

watch(isOpen, (open) => {
  const main = document.getElementById("main-area");
  if (open) {
    document.body.style.overflow = "hidden";
    if (main) main.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
    if (main) main.style.overflow = "";
  }
});

const toggleMenu = (): void => {
    isOpen.value = !isOpen.value;
}

const closeMenuTitle = (): void => {
  isOpen.value = false;
  router.push('/');
};

const aboutMeOptions = {
  "My Bio": "/about-me",
  "Hobbies & Interests": "/interests"
}

const projectsOptions = {
  "All Projects": "/projects",
  "POVO Class Registration": "/povo-interface",
  "clairgreen.com": "/my-website",
  "Turn-Based Battle Sim": "/rpg-battle-sim",
  "Eagle Project": "/eagle-project",
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400;700&display=swap');

.navbar {
  font-family: 'Merriweather', sans-serif;
  transition: transform .5s ease;
}

.site-title {
  font-family: 'Merriweather', sans-serif;
  text-shadow: 0 0 3px #a8c3b4;
}

.site-title:hover, .site-title-mobile:hover, .hamburger:hover {
  color: #b0cfc2; 
  text-shadow: 0px 0px 3px #90b7a7;
  transform: scale(1.0375);
  cursor: pointer;
}

.site-title-mobile {
    text-shadow: 0 0 3px #a8c3b4;
}


.link,
.links-dropdown {
  text-decoration: none;
  color: #f0f7f2;
  text-shadow: 0px 0px 4px #a8c3b4;
  display: flex;                    
  height: auto;
  cursor: pointer;
}

.link:hover {
  color: #b0cfc2;
  text-shadow: 0px 0px 4px #6a998f;
  transform: scale(1.0375);
  transition: transform 0.5s ease;
}

.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.menu-slide-enter-from {
  transform: translateX(100%);
  opacity: 1;
}

.menu-slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}


.menu-slide-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.menu-slide-leave-to {
  transform: translateX(100%);
  opacity: 1;
}

</style>